<template>
    <div class="user_order no-trans" v-loading="loading">
        <div class="order_titles">立即点评</div>
        <div class="user_order_box">
            <div class="form_flex" v-for="(item,index) in form_list" :key="index" v-if="item.show_num==form_ac">
                <div class="form_title">
                    <span v-if="item.out_show">*</span>
                    {{ item.title }}
                </div>
                <div class="form_input">
                    <el-input type="textarea" :rows="5"  v-model="item.form_val" :placeholder="item.placeholder_text"></el-input>
                </div>
            </div>

            <div class="form_flex" >
                <div class="form_title">
                    
                     
                </div>
                <div class="form_btn_flex">
                   <div class="btns1" @click="handle_end">确认</div>
                   <div class="btns2" @click="handle_back">取消</div>
                </div>
            </div>
        </div>
        
    </div>
</template>
<script>
import { mapState} from 'vuex'
 
 

export default {
    components: {
       
    },
    name: "homes",
    data() {
        return {
            loading: false,
            form_id:0,
            form:{
                cmss:'',//查明事实
                fyrd:'',//法院认定
                flsy:'',//法律适用
                fypj:'',//法院判决
                fljy:'',//法律建议
                ftdc:'',//法庭调查
                zjzz:'',//证据质证
                fybl:'',//法院辩论
                tsbl:'',//庭审笔录
                labj:'',//类案比较
                fgclkj:'',//法官裁量空间
            },
            form_ac:1,//1初级 2中级 3高级 4特技
            form_list:[
                {
                    show_num:'1',//
                    title:'查明事实',
                    out_show:true,//是否必填 是否显示*
                    form_text:'cmss',//提交的字段
                    form_val:'',//提交的值
                    placeholder_text:'请输入查明事实',
                },
                {
                    show_num:'1',//
                    title:'法院认定',
                    out_show:true,//是否必填 是否显示*
                    form_text:'fyrd',//提交的字段
                    form_val:'',//提交的值
                    placeholder_text:'请输入法院认定',
                },
                { 
                    show_num:'1',//
                    title:'法律适用',
                    out_show:true,//是否必填 是否显示*
                    form_text:'flsy',//提交的字段
                    form_val:'',//提交的值
                    placeholder_text:'请输入法律适用',
                },
                {
                    show_num:'1',//
                    title:' 法律判决',
                    out_show:true,//是否必填 是否显示*
                    form_text:'fypj',//提交的字段
                    form_val:'',//提交的值
                    placeholder_text:'请输入法律判决',
                },

                 {
                    show_num:'1',//
                    title:' 法律建议',
                    out_show:true,//是否必填 是否显示*
                    form_text:'fljy',//提交的字段
                    form_val:'',//提交的值
                    placeholder_text:'请输入法律建议',
                },
                {
                    show_num:'2',//
                    title:'法院调查',
                    out_show:true,//是否必填 是否显示*
                    form_text:'ftdc',//提交的字段
                    form_val:'',//提交的值
                    placeholder_text:'请输入法院调查',
                },
                {
                    show_num:'2',//
                    title:'证据质证',
                    out_show:true,//是否必填 是否显示*
                    form_text:'zjzz',//提交的字段
                    form_val:'',//提交的值
                    placeholder_text:'请输入证据质证',
                },
                {
                    show_num:'2',//
                    title:'法院辩论',
                    out_show:true,//是否必填 是否显示*
                    form_text:'fybl',//提交的字段
                    form_val:'',//提交的值
                    placeholder_text:'请输入法院辩论',
                },
                {
                    show_num:'2',//
                    title:'查明事实',
                    out_show:true,//是否必填 是否显示*
                    form_text:'cmss',//提交的字段
                    form_val:'',//提交的值
                    placeholder_text:'请输入查明事实',
                },
                {
                    show_num:'2',//
                    title:'法院认定',
                    out_show:true,//是否必填 是否显示*
                    form_text:'fyrd',//提交的字段
                    form_val:'',//提交的值
                    placeholder_text:'请输入法院认定',
                },
                {
                    show_num:'2',//
                    title:'法律适用',
                    out_show:true,//是否必填 是否显示*
                    form_text:'flsy',//提交的字段
                    form_val:'',//提交的值
                    placeholder_text:'请输入法律适用',
                },
                {
                    show_num:'2',//
                    title:'法律建议',
                    out_show:true,//是否必填 是否显示*
                    form_text:'fljy',//提交的字段
                    form_val:'',//提交的值
                    placeholder_text:'请输入法律建议',
                },


                {
                    show_num:'3',//
                    title:'法庭调查',
                    out_show:true,//是否必填 是否显示*
                    form_text:'ftdc',//提交的字段
                    form_val:'',//提交的值
                    placeholder_text:'请输入法庭调查',
                },
                {
                    show_num:'3',//
                    title:'证据质证',
                    out_show:true,//是否必填 是否显示*
                    form_text:'zjzz',//提交的字段
                    form_val:'',//提交的值
                    placeholder_text:'请输入证据质证',
                },
                {
                    show_num:'3',//
                    title:'庭审笔录',
                    out_show:true,//是否必填 是否显示*
                    form_text:'tsbl',//提交的字段
                    form_val:'',//提交的值
                    placeholder_text:'请输入庭审笔录',
                },
                {
                    show_num:'3',//
                    title:'法院辩论',
                    out_show:true,//是否必填 是否显示*
                    form_text:'fybl',//提交的字段
                    form_val:'',//提交的值
                    placeholder_text:'请输入法院辩论',
                },
                {
                    show_num:'3',//
                    title:'查明事实',
                    out_show:true,//是否必填 是否显示*
                    form_text:'cmss',//提交的字段
                    form_val:'',//提交的值
                    placeholder_text:'请输入查明事实',
                },
                {
                    show_num:'3',//
                    title:'法院认定',
                    out_show:true,//是否必填 是否显示*
                    form_text:'fyrd',//提交的字段
                    form_val:'',//提交的值
                    placeholder_text:'请输入法院认定',
                },
                {
                    show_num:'3',//
                    title:' 法律适用',
                    out_show:true,//是否必填 是否显示*
                    form_text:'flsy',//提交的字段
                    form_val:'',//提交的值
                    placeholder_text:'请输入法律适用',
                },
                {
                    show_num:'3',//
                    title:' 类案比较',
                    out_show:true,//是否必填 是否显示*
                    form_text:'labj',//提交的字段
                    form_val:'',//提交的值
                    placeholder_text:'请输入类案比较',
                },
                {
                    show_num:'3',//
                    title:'法官裁量空间',
                    out_show:true,//是否必填 是否显示*
                    form_text:'fgclkj',//提交的字段
                    form_val:'',//提交的值
                    placeholder_text:'请输入法官裁量空间',
                },
                {
                    show_num:'3',//
                    title:'法律建议',
                    out_show:true,//是否必填 是否显示*
                    form_text:'fljy',//提交的字段
                    form_val:'',//提交的值
                    placeholder_text:'请输入法律建议',
                },


                

                {
                    show_num:'4',//
                    title:'法庭调查',
                    out_show:true,//是否必填 是否显示*
                    form_text:'ftdc',//提交的字段
                    form_val:'',//提交的值
                    placeholder_text:'请输入法庭调查',
                },
                {
                    show_num:'4',//
                    title:'证据质证',
                    out_show:true,//是否必填 是否显示*
                    form_text:'zjzz',//提交的字段
                    form_val:'',//提交的值
                    placeholder_text:'请输入证据质证',
                },
                {
                    show_num:'4',//
                    title:'庭审笔录',
                    out_show:true,//是否必填 是否显示*
                    form_text:'tsbl',//提交的字段
                    form_val:'',//提交的值
                    placeholder_text:'请输入庭审笔录',
                },
                {
                    show_num:'4',//
                    title:'法院辩论',
                    out_show:true,//是否必填 是否显示*
                    form_text:'fybl',//提交的字段
                    form_val:'',//提交的值
                    placeholder_text:'请输入法法院辩论',
                },
                {
                    show_num:'4',//
                    title:'查明事实',
                    out_show:true,//是否必填 是否显示*
                    form_text:'cmss',//提交的字段
                    form_val:'',//提交的值
                    placeholder_text:'请输入查明事实',
                },
                {
                    show_num:'4',//
                    title:'法院认定',
                    out_show:true,//是否必填 是否显示*
                    form_text:'fyrd',//提交的字段
                    form_val:'',//提交的值
                    placeholder_text:'请输入法院认定',
                },
                {
                    show_num:'4',//
                    title:' 法律适用',
                    out_show:true,//是否必填 是否显示*
                    form_text:'flsy',//提交的字段
                    form_val:'',//提交的值
                    placeholder_text:'请输入法律适用',
                },
                {
                    show_num:'4',//
                    title:' 类案比较',
                    out_show:true,//是否必填 是否显示*
                    form_text:'labj',//提交的字段
                    form_val:'',//提交的值
                    placeholder_text:'请输入类案比较',
                },
                {
                    show_num:'4',//
                    title:'法官裁量空间',
                    out_show:true,//是否必填 是否显示*
                    form_text:'fgclkj',//提交的字段
                    form_val:'',//提交的值
                    placeholder_text:'请输入法官裁量空间',
                },
                {
                    show_num:'4',//
                    title:'法律建议',
                    out_show:true,//是否必填 是否显示*
                    form_text:'fljy',//提交的字段
                    form_val:'',//提交的值
                    placeholder_text:'请输入法律建议',
                },
            ],
            
           
        }
    },
    computed: {
        ...mapState(['vuex_user', 'vuex_unread_number'])
    },
    watch: {

    },
    created() {
        this.form_ac=this.$route.query.grade
        this.form_id=this.$route.query.id
        this.get_detial()
    },
    methods: {
        get_detial(){
            this.loading=true
            this.$api("lawyerCaseCommentDetail", {
                id:this.$route.query.id
			}, "get").then((res) => {
                this.loading = false
                this.loading=false
                console.log('律师点评详情',res)
                if (res.code == 1) {
                    this.order_detial=res.data
                    this.order_list=[]
                    let status=0
                    if(res.data.lawyer_comment){
                        status=res.data.lawyer_comment[0].status
                        this.status=status
                        res.data.lawyer_comment.forEach((e)=>{
                            if(e.status==10){
                                console.log('e',e)
                              
                                this.form_list.forEach((v)=>{
                                    if(v.show_num==this.$route.query.grade){
                                        v.form_val=e[v.form_text]
                                    }
                                })
                                // this.order_list.push(e)
                            }
                        })
                    }
                    
                  

   
                } else {
                    alertErr(res.msg)
                }
            });
        },


        handle_end(){
            let form={}            
            for(let i=0;i<this.form_list.length;i++){
                let e=this.form_list[i]
                if(e.show_num==this.form_ac){
                    if(!e.form_val){
                        alertErr(e.placeholder_text)
                        return
                    }else{
                        form[e.form_text]=e.form_val
                    }
                }
            }
            console.log('form',form)
            this.loading=true
            this.$api("caseLawyerComment", {
               id:this.form_id,
               ...form,
			}, "post").then((res) => {
                this.loading = false
                this.loading=false
                console.log('我的点评列表',res)
                if (res.code == 1) {
                    alertSucc('提交成功')
                    this.$router.back()
                } else {
                    alertErr(res.msg)
                }
            });

            
        },
        handle_back(){
            this.$router.back()

        },



    },

}
</script>
<style scoped lang="less">
.user_order {
    .order_titles{
        width: 1196px;
        height: 56px;
        background: #FFFFFF;
        border-radius: 0px 0px 0px 0px;
        padding: 0 32px;
        font-family: Microsoft YaHei, Microsoft YaHei;
        font-weight: bold;
        font-size: 16px;
        color: #333333;
        line-height: 56px;
    }
    .user_order_box{
        padding-top:56px;    
        padding-bottom: 75px;
        background-color: #FFFFFF;
        margin-top: 16px;
        .form_flex{
            display: flex;
            margin-bottom: 20px;
            .form_title{
                width: 150px;
                flex-shrink: 0;
                text-align: right;
                font-family: Microsoft YaHei, Microsoft YaHei;
                font-weight: 400;
                font-size: 14px;
                color: #999999;
                margin-left: 100px;
                padding-right: 24px;
                span{
                    color: #FD4C5C;
                    margin-right: 5px;
                }
            }
            .form_input{
                width: 749px;
            }
            .form_btn_flex{
                display: flex;
                align-items: center;
                .btns1{
                    width: 76px;
                    height: 40px;
                    background: #377CFD;
                    border-radius: 4px 4px 4px 4px;
                    font-weight: 400;
                    font-size: 14px;
                    color: #FFFFFF;
                    text-align: center;
                    line-height: 40px;
                    cursor: pointer;
                    margin-right: 24px;
                }
                .btns2{
                    width: 76px;
                    height: 40px;
                    border-radius: 4px 4px 4px 4px;
                    border: 1px solid #377CFD; 
                    font-family: Microsoft YaHei, Microsoft YaHei;
                    font-weight: 400;
                    font-size: 14px;
                    color: #377CFD;
                    text-align: center;
                    line-height: 40px;
                    cursor: pointer;
                }
            }
        }
        
        
    }


}
</style>
<style scoped lang="less">
@media (max-width: 1024px) {
    .user_order.no-trans {
        max-width: 100%;
        min-width: 0;
        font-size: 14px;
        line-height: 1.6;
    }
    .user_order.no-trans .order_titles {
        max-width: 100%;
        min-width: 0;
        width: 100%;
        height: 56px;
        border-radius: 0px 0px 0px 0px;
        padding: 0 16px;
        font-size: 16px;
        line-height: 1.6;
    }
    .user_order.no-trans .user_order_box {
        padding-top: 16px;
        padding-bottom: 16px;
        margin-top: 16px;
    }
    .user_order.no-trans .user_order_box .form_flex {
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
        margin-bottom: 16px;
        flex-direction: column;
        align-items: stretch;
    }
    .user_order.no-trans .user_order_box .form_flex .form_title {
        width: 100%;
        font-size: 14px;
        margin-left: 16px;
        padding-right: 16px;
        text-align: left;
        line-height: 1.6;
        padding: 0;
    }
    .user_order.no-trans .user_order_box .form_flex .form_title span {
        margin-right: 5px;
    }
    .user_order.no-trans .user_order_box .form_flex .form_input {
        max-width: 100%;
        min-width: 0;
        width: 100%;
    }
    .user_order.no-trans .user_order_box .form_flex .form_btn_flex {
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
    }
    .user_order.no-trans .user_order_box .form_flex .form_btn_flex .btns1 {
        width: 76px;
        height: auto;
        border-radius: 4px 4px 4px 4px;
        font-size: 14px;
        line-height: 1.6;
        margin-right: 16px;
        min-height: 44px;
        padding-top: 12px;
        padding-bottom: 12px;
    }
    .user_order.no-trans .user_order_box .form_flex .form_btn_flex .btns2 {
        width: 76px;
        height: auto;
        border-radius: 4px 4px 4px 4px;
        font-size: 14px;
        line-height: 1.6;
        min-height: 44px;
        padding-top: 12px;
        padding-bottom: 12px;
    }
}
</style>
